// src/component/Auth/AuthService.js

import EventEmitter from 'eventemitter3'
import decode from 'jwt-decode'
import router from '../../router'
import Auth0Lock from 'auth0-lock'
import axios from 'axios'

class AuthService {
  accessToken
  idToken
  expiresAt
  authenticated = this.isAuthenticated()
  authNotifier = new EventEmitter()
  userProfile
  roles
  quberUser

  // auth0 = new auth0.WebAuth({
  //   domain: AUTH_CONFIG.domain,
  //   audience: AUTH_CONFIG.audience,
  //   grantType: AUTH_CONFIG.grantType,
  //   clientID: AUTH_CONFIG.clientID,
  //   redirectUri: AUTH_CONFIG.redirectUri,
  //   responseType: AUTH_CONFIG.responseType,
  //   scope: AUTH_CONFIG.scope
  // });

  constructor () {
    // Add callback Lock's `authenticated` event
    this.lock.on('authenticated', this.setSession.bind(this))
    // Add callback for Lock's `authorization_error` event
    // this.lock.on('authorization_error', error => console.log(error))
  }

  lock = new Auth0Lock(process.env.VUE_APP_AUTH0_CLIENT_ID, process.env.VUE_APP_AUTH0_DOMAIN, {
    autoclose: true,
    usernameStyle: 'email',
    allowedConnections: ['Username-Password-Authentication'],
    allowSignUp: false,
    // closable: false,
    theme: {
      primaryColor: '#527F8F',
      hideMainScreenTitle: true,
      logo: 'https://quberimages.s3.ca-central-1.amazonaws.com/groups/quber/logo.png'
    },
    auth: {
      audience: process.env.VUE_APP_AUTH0_AUDIENCE,
      responseType: process.env.VUE_APP_AUTH0_RESPONSE_TYPE,
      grantType: process.env.VUE_APP_AUTH0_GRANT_TYPE,
      // redirectUrl: process.env.VUE_APP_AUTH0_REDIRECT_URI,
      params: {
        scope: process.env.VUE_APP_AUTH0_SCOPE
      }
    }
  })

  async login () {
    if (!this.isAuthenticated()) {
      // Call the show method to display the widget.
      this.lock.show()
    }
  }

  hide () {
    // Call the show method to display the widget.
    this.lock.hide()
  }

  async setSession (authResult) {
    this.idToken = authResult.idToken
    this.roles = this.getRoles()
    if (authResult && authResult.accessToken && authResult.idToken) {
      // Set the time that the access token will expire at
      const localExpiresAt = JSON.stringify(
        parseInt(authResult.expiresIn, 10) * 1000 + new Date().getTime()
      )

      this.idToken = authResult.idToken
      this.accessToken = authResult.accessToken
      this.expiresAt = localExpiresAt
      this.roles = this.getRoles()

      sessionStorage.setItem('loggedIn', true)
      sessionStorage.setItem('jwtToken', this.accessToken)
      this.getQuberUser()
      if (this.quberUser) {
        sessionStorage.setItem('loggedInUser', this.quberUser.userId)
      }
      this.authenticated = true
      this.authNotifier.emit('authChange', { authenticated: true, admin: this.isAdmin(), paymentAdmin: this.isPaymentAdmin(), vendorAdmin: this.isVendorAdmin(), roles: this.getRoles() })

      if (this.lock && this.accessToken) {
        this.lock.getUserInfo(this.accessToken, (_err, profile) => {
          if (profile) {
            this.userProfile = profile
          }
        })
      }
      // navigate to the home route
      router.push('/').catch(() => {})
    }
  }

  getAccessToken () {
    const accessToken = this.accessToken

    if (!accessToken) {
      throw new Error('No access token found')
    }

    return accessToken
  }

  getProfile (cb) {
    const accessToken = this.getAccessToken()

    this.lock.getUserInfo(accessToken, (err, profile) => {
      if (profile) {
        this.userProfile = profile
      }

      cb(err, profile)
    })
  }

  renewSession () {
    if (sessionStorage.getItem('loggedIn') === 'true') {
      this.lock.checkSession({}, (err, authResult) => {
        if (authResult && authResult.accessToken && authResult.idToken) {
          this.setSession(authResult)
        } else if (err) {
          this.logout()
          // console.log(err)
          alert(`Could not get a new token (${err.error}: ${err.error_description}).`)
        }
      })
    }
  }

  logout () {
    // Clear access token and ID token from local storage
    this.idToken = null
    this.accessToken = null
    this.expiresAt = null
    this.userProfile = null
    this.roles = null
    this.quberUser = null

    this.authNotifier.emit('authChange', false)

    sessionStorage.removeItem('loggedIn')
    sessionStorage.clear()
    this.lock.show()

    // navigate to the home route
    router.replace('/')
  }

  isAuthenticated () {
    // Check whether the current time is past the
    // access token's expiry time
    const isLoggedIn = sessionStorage.getItem('loggedIn') === 'true'

    return this.expiresAt && isLoggedIn && new Date().getTime() < this.expiresAt
  }

  getRole () {
    const namespace = process.env.VUE_APP_AUTH0_NAMESPACE
    const idToken = this.idToken

    if (idToken) {
      return decode(idToken)[`${namespace}/role`] || null
    }
  }

  getRoles () {
    const namespace = process.env.VUE_APP_AUTH0_NAMESPACE
    const idToken = this.idToken

    if (idToken) {
      return decode(idToken)[`${namespace}/roles`] || null
    }
  }
  getUserProfile () {
    return this.userProfile
  }
  getQuberUser () {
    if (!this.isAuthenticated()) {
      this.quberUser = null
      return this.quberUser
    }
    const namespace = process.env.VUE_APP_AUTH0_NAMESPACE
    const idToken = this.idToken
    const accessToken = this.accessToken
    let username = ''
    if (this.quberUser) {
      return this.quberUser
    }
    if (idToken) {
      username = decode(idToken)[`email`] || null
      if (!username) {
        this.quberUser = null
        return this.quberUser
      }
    }
    const myHeaders = { 'Authorization': `Bearer ${accessToken}` }
    const url = process.env.VUE_APP_QUBER_SERVICE_ITEMS
    axios.get(`${url}/users?username=${username}`, { headers: myHeaders })
      .then(response => {
        this.quberUser = response.data
        sessionStorage.setItem('loggedInUser', this.quberUser.userId)
      })
      .catch(e => {
        // console.log(e)
        // this.errors.push(e)
      })
    //      return { id: '1282', username: username }
    return this.quberUser
  }

  isAdmin () {
    return (this.roles.indexOf('admin') > -1)
  }

  isPaymentAdmin () {
    return (this.roles.indexOf('payment-admin') > -1)
  }

  isVendorAdmin () {
    return (this.roles.indexOf('vendor-admin') > -1)
  }

  hasRole (role) {
    return this.roles.includes(role)
  //    return (this.roles != null && this.roles.indexOf(role) > -1)
  }

  hasAnyRole (passedRoles) {
    if (!passedRoles || !this.roles) return false
    return (this.roles.some(r => passedRoles.includes(r)))
  }
}

export default new AuthService()
